import { render } from "./editCustomizeSetup.vue?vue&type=template&id=3fa9c1ba&scoped=true"
import script from "./editCustomizeSetup.vue?vue&type=script&lang=js"
export * from "./editCustomizeSetup.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./editCustomizeSetup.vue?vue&type=style&index=1&id=3fa9c1ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa9c1ba"]])

export default __exports__